import type { RewardStatus, RewardsListResponse, TimelineMilestone } from "./types";

const completedStatusLabels: Partial<Record<RewardStatus, string>> = {
  claimed: "CLAIMED",
  active: "ACTIVE",
};

export function getCompletedStatusLabel(status: RewardStatus): string | null {
  return completedStatusLabels[status] ?? null;
}

export function deriveTimelineMilestones(data: RewardsListResponse): TimelineMilestone[] {
  const allRewards = [...data.MemberRewards, ...data.MemberPerks];

  return allRewards
    .sort((a, b) => a.TimelineOrder - b.TimelineOrder)
    .map(reward => ({
      RewardId: reward.Id,
      Label: reward.DisplayName,
      Status: reward.Status,
      IconType: reward.TimelineIconType,
      DaysUntilReveal: reward.DaysUntilUnlock,
    }));
}

export function formatCurrency(amount: number, currency = "GBP"): string {
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  }).format(amount);
}
